window.VegasCart = {
	add: function (id, cnt, callback) {
		cnt = cnt || 1;
		let params = VegasCart.formData({id: id, cnt: cnt});

		this.addRequest(params, function (data) {
			if (!data.error) {
				VegasCart.total(data);
			}

			if (callback) callback();
		});
	},

	addRequest: function (params, callback) {
		yaCounterReachGoal('cart-add');

		$.post('/cart/add_product', params, function (data) {
			if (typeof callback == 'function')
				callback(data);
		});
	},

	changeCnt: function (id, cnt, lparams, callback) {
		lparams = lparams || {};
		lparams.id = id;
		lparams.cnt = cnt;

		let params = VegasCart.formData(lparams);

		$.post('/cart/change_product', params, function (data) {
			VegasCart.total(data);

			if (typeof callback == 'function')
				callback(data);
		});
	},

	remove: function (id, callback) {
		let params = VegasCart.formData({
			id: id,
		});

		this.removeRequest(params, function (data) {
			VegasCart.total(data);

			if (callback) callback();
		});
	},

	removeRequest: function (params, callback) {
		yaCounterReachGoal('cart-del');

		$.post('/cart/del_product', params, function (data) {
			if (typeof callback == 'function') {
				callback(data);
			}
		});
	},

	total: function (data) {
		if (typeof data.products_count !== 'undefined') {
			$('[data-cart=products-count]').text(data.products_count);
		}

		if (typeof data.cart_sum !== 'undefined') {
			$('[data-cart=cart-total]').text(output_roubles(data.cart_sum));
			let infoArea = document.querySelector('.cart-page .info-area');
			if (infoArea) {
				if(data.cart_sum === 0) {
					infoArea.style.display = 'none';
				} else {
					infoArea.style.display = '';
				}
			}
		}

		if (typeof data.cart_sum_products !== 'undefined') {
			$('[data-cart=products-total]').text(output_roubles(data.cart_sum_products));
		}

		if (typeof data.delivery_sum !== 'undefined') {
			let t;
			if (isNaN(data.delivery_sum)) {
				t = data.delivery_sum;
			} else {
				t = data.delivery_sum > 0 ? output_roubles(data.delivery_sum) : 'Бесплатно';
			}

			$('[data-cart=delivery-total]').text(t);
		}

		this.totalProducts(data);
		this.totalCartProductView(data);
	},

	totalProducts: function (data) {
		if (typeof data.products_totals !== 'undefined') {
			for (let i in data.products_totals) {
				let item = data.products_totals[i];
				$('.cart-table tr[data-pivot_id="' + item.pivot_id + '"] .price-total').text(output_roubles(item.price_total));
			}
		}
	},

	totalCartProductView(data) {
		if (typeof data.product_cart_view !== 'undefined') {
			for (let i in data.product_cart_view) {
				let item = data.product_cart_view[i];

				var $cartItem = $('.cart-product[data-pivot_id="' + item.pivot_id + '"]');
				$cartItem.after(item.view);
				$cartItem.remove();
			}
		}
	},

	updateTotalAll: function () {
		$.get('/cart/get_totals', VegasCart.formData(), function (data) {
			VegasCart.total(data);
		});
	},

	formData: function (appendParams) {
		appendParams = appendParams || {};
		let resultParams = $('.form-order.active').serializeArray();

		for (let name in appendParams) {
			resultParams.push({name: name, value: appendParams[name]});
		}

		resultParams.push({name: '_token', value: App.csrf});

		return resultParams;
	},
};

/**
 * Прослушиватели событий корзины
 **/
let $window = $(window),
	$body = $('body'),
	$document = $(document)
;

// list
$document.on('click', '[data-product-item] [data-cart=add]', function () {
	let self = this;
	let $product = $(this).closest('[data-product-item]')

	VegasCart.add($product.data('id'), null, function () {
		$(self).attr('data-cart', 'remove');
		$product.addClass('in-cart');
	});

	return false;
});

$document.on('click', '[data-product-item] [data-cart="remove"]', function () {
	let self = this;
	let $product = $(this).closest('[data-product-item]');

	VegasCart.remove($product.data('id'), function () {
		$(self).attr('data-cart', 'add');
		$product.removeClass('in-cart');
	});

	return false;
});

// cart
$document.on('click', '[data-product-cart-item] [data-cart="remove"]', function () {
	let self = this;
	let $product = $(this).closest('[data-product-cart-item]');

	VegasCart.remove($product.data('id'), function () {
		$product.remove();

		let $cartTable = $('.cart-table');
		let productsCounts = $cartTable.find('[data-product-cart-item]').length;
		if (productsCounts === 0) {
			location.reload();
		}
	});

	return false;
});

// product show
$document.on('click', '[data-product] [data-cart="add"]', function () {
	let self = this;
	let $product = $(this).closest('[data-product]');
	let cnt = $product.find('[name=cnt]').val();

	VegasCart.add($product.data('id'), cnt, function () {
		$product.addClass('in-cart');
		$(self).text('В корзине').attr('disabled', 'disabled');
	});

	return false;
});
$document.on('click', '[data-product] [data-cart="remove"]', function () {
	let $product = $(this).closest('[data-product]');

	VegasCart.remove($product.data('id'), function () {
		$product.removeClass('in-cart');
		$product.find('[data-cart="add"]').text('В корзину').removeAttr('disabled');
	});

	return false;
});
$document.on('change', '[data-product] input[name=cnt]', function () {
	let cnt = $(this).val();

	let $product = $(this).closest('[data-product]');
	let id = $product.data('id');

	if ($product.hasClass('in-cart')) {
		VegasCart.changeCnt(id, cnt);
	}

	return false;
});

$document.on('input', '.count-items input[name=cnt]', function () {
	if (this.value === '' || this.value < this.min) {
		this.value = this.min;
	}
});

$document.on('change', '.cart-table [name=cnt]', function () {
	let cnt = $(this).val();
	let $product = $(this).closest('[data-product-cart-item]');
	let id = $product.data('id');

	VegasCart.changeCnt(id, cnt, {
		get_products_totals: true
	}, function (data) {

	});

	return false;
});

$document.on('change', '#checkbox-all, .p-ch', function () {
	let cnt = $('.p-ch:checked').length;
	if (cnt > 0) {
		$('.form-order').removeAttr('disabled', 'disabled').find('button[type=submit]').removeAttr('disabled', 'disabled');
	} else {
		$('.form-order').attr('disabled', 'disabled').find('button[type=submit]').attr('disabled', 'disabled');
	}

	VegasCart.updateTotalAll();
});

$('.nav-checkout-types a').click(function () {
	$('.p-ch').attr('form', $(this).data('form'));
	$('.form-order').removeClass('active');
	$('#' + $(this).data('form')).addClass('active');
});

// Способ доставки
$('select.type_delivery').change(function () {
	let val = $(this).val();
	$('.delivery-info').each(function (i, e) {
		$(e).hide();
		$(e).find('input.mark-require').removeAttr('required');
	});
	let $dl = $('.delivery-info[data-type="' + val + '"]');
	$dl.find('input.mark-require').attr('required', 'required');
	$dl.show();

	VegasCart.updateTotalAll();
});

// Тип компании
$('[data-toggle=companyType]').change(function () {
	let $self = $(this);
	let type = parseInt($self.val());

	if (type === 1) {
		$('input[name=company_ogrn]').attr('placeholder', 'ОГРНИП*');
	} else {
		$('input[name=company_ogrn]').attr('placeholder', 'ОГРН*');
	}

	if (type === 2 || type === 3) {
		$('#company_kpp').attr('required', 'required');
		$('.kpp').slideDown();
	} else {
		$('#company_kpp').removeAttr('required');
		$('.kpp').slideUp();
	}

	return false;
}).trigger('change');

// Копи юр адрес
$('[data-toggle=copyAddress]').click(function () {
	$('#company_fact_address').val($('#company_legal_address').val());
	$(this).hide();
	return false;
});

$('.form-order').submit(function () {
	let $btn = $(this).find('button[type=submit]');
	$btn.attr('disabled', 'disabled').text('Оформляем заказ...');
})

$("#form-one-click").submit(function () {
	let $modal = $(this).closest('#vg-prd-one-click');
	let $btn = $modal.find('button[type=submit]');
	$btn.attr('disabled', 'disabled').text('Оформляем заказ...');
});
